import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useUser } from "../../util/userContext/UserContext";
import ProductInList from "./internal/list/ProductInList";
import ProductInDetail from "./internal/detail/ProductInDetail";
import ProductExList from "./external/list/ProductExList";
import ProductExDetail from "./external/detail/ProductExDetail";

export default function Product() {
    const { key } = useLocation()
    const { user } = useUser()

    const isIn = user
        // inOut === 0 : 내부, inOut === 1 : 외부
        ? user.inOutFlag === 0
            // 1 = 내부 / 2 = 외부 / -1 = 없음
            ? 1 // TODO: << 원래 1(변경되어있으면 테스트 하고 있던 것임)
            : 2 // TODO: << 원래 2(변경되어있으면 테스트 하고 있던 것임)
        : -1

    return <Routes>
        {isIn === 1 && <>
            <Route key={key} path={"list"} element={<ProductInList />} />
            <Route key={key} path={"detail/:id"} element={<ProductInDetail />} />
            <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
        </>}

        {isIn === 2 && <>
            <Route key={key} path={"list"} element={<ProductExList />} />
            <Route key={key} path={"detail/:id"} element={<ProductExDetail />} />
            <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
        </>}
    </Routes>
}